export default "__VITE_ASSET__DirrkYDw__"